export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="rounded-3xl overflow-hidden bg-background-50 aspect-[21/9] mb-10 md:mb-14">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20lifestyle%20product%20arrangement%20featuring%20carefully%20styled%20fashion%20accessories%20including%20a%20leather%20tote%20bag%20soft%20scarf%20and%20minimalist%20jewelry%20pieces%20placed%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20natural%20window%20light%20creating%20gentle%20highlight%20patterns%2C%20sophisticated%20editorial%20styling%20with%20artistic%20negative%20space%2C%20warm%20neutral%20color%20palette%2C%20high%20end%20catalog%20photography%20with%20refined%20luxurious%20feel&width=1800&height=771&seq=cta-product-v3&orientation=landscape"
              alt="ACBuySpreadsheet product collection"
              className="w-full h-full object-cover"
            />
          </div>

          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Get Your
            <br />
            <span className="italic text-primary-600">ACBuy Spreadsheet</span>
            <br />
            Today
          </h2>

          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-md mx-auto">
            Start exploring the ACBuySpreadsheet system today and improve your workflow efficiency with the smartest tracking solution available.
          </p>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center mt-8 px-10 py-4 bg-foreground-950 text-white rounded-full text-base font-semibold hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}